export const PaymentCardSVG = ({ className }: { className?: string }) => (
    <svg
        className={className}
        data-testid="payment-card-icon"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.668 10.6673V8.00065H5.33464V10.6673H26.668ZM26.668 14.6673H5.33464V24.0007H26.668V14.6673ZM5.33464 5.33398H26.668C28.4453 5.33398 29.3346 6.22332 29.3346 8.00065V24.0007C29.3346 25.7847 28.4453 26.674 26.668 26.6673H5.33464C3.5573 26.674 2.66797 25.7847 2.66797 24.0007V8.00065C2.66797 6.22332 3.5573 5.33398 5.33464 5.33398ZM14.668 18.6673H21.3346C22.224 18.6673 22.668 19.1113 22.668 20.0007C22.668 20.8873 22.224 21.3313 21.3346 21.3313H14.668C13.7786 21.3313 13.3346 20.8873 13.3346 19.9993C13.3346 19.1113 13.7786 18.6673 14.668 18.6673ZM9.33464 18.6673H10.668C11.5573 18.6673 12.0013 19.1113 12.0013 20.0007C12.0013 20.8873 11.5573 21.3313 10.668 21.3313H9.33464C8.4453 21.3313 8.0013 20.8873 8.0013 19.9993C8.0013 19.1113 8.4453 18.6673 9.33464 18.6673Z"
            fill="#0C2340"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6667 18.666H21.3333C22.2227 18.666 22.6667 19.11 22.6667 19.9993C22.6667 20.886 22.2227 21.33 21.3333 21.33H14.6667C13.7773 21.33 13.3333 20.886 13.3333 19.998C13.3333 19.11 13.7773 18.666 14.6667 18.666ZM9.33333 18.666H10.6667C11.556 18.666 12 19.11 12 19.9993C12 20.886 11.556 21.33 10.6667 21.33H9.33333C8.444 21.33 8 20.886 8 19.998C8 19.11 8.444 18.666 9.33333 18.666Z"
            fill="#FB534A"
        />
    </svg>
);
